<template>
  <v-tabs
    class="nav-tabs"
    slot="extension"
    color="transparent"
    grow>
    <v-tabs-slider color="transparent"></v-tabs-slider>
    <v-tab
      @click="$router.push({ name: 'home' })"
      :ripple="false"
      :style="$route.name === 'home' ? `width: ${100 / 3}px; background-color: rgba(158, 158, 158, 0.2);` : `width: ${100 / 3}px;`"
      class="nav-tab">
      Home
    </v-tab>
    <v-tab
      @click="$router.push({ name: 'senate_landing' })"
      :ripple="false"
      :style="$route.name === 'senate_landing' ? `width: ${100 / 3}px; background-color: rgba(158, 158, 158, 0.2);` : `width: ${100 / 3}px;`"
      class="nav-tab">
      Senate
    </v-tab>
    <v-tab
      @click="$router.push({ name: 'house_landing' })"
      :ripple="false"
      :style="$route.name === 'house_landing' ? `width: ${100 / 3}px; background-color: rgba(158, 158, 158, 0.2);` : `width: ${100 / 3}px;`"
      class="nav-tab">
      House
    </v-tab>
  </v-tabs>
</template>

<script>
const name = 'nav_secondary'

export default {
  name
}
</script>

<style>
.nav-tabs {
  border: 1px solid #BDBDBD;
  border-radius: 50px;
  width: 50%;
  margin: 5px auto;
}

.nav-tab {
  border-left: 1px solid #BDBDBD;
}

.nav-tab:nth-child(2) {
  border-left: none;
  border-radius: 50px 0 0 50px;
}

.nav-tab:last-child {
  border-radius: 0 50px 50px 0;
}

.nav-tab:hover {
  background-color: rgba(158, 158, 158, 0.2);
}

.tabs__container {
  height: 30px !important;
}

.tabs__container--grow .tabs__div {
  height: 30px !important;
}

@media only screen and (max-width: 960px) {
  .nav-tabs {
    width: 75%;
  }
}

@media only screen and (max-width: 420px) {
  .nav-tabs {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TopNavSecondary.vue